import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import SuperTokens from 'supertokens-auth-react';
import { signOut } from 'supertokens-auth-react/recipe/session';
import { FEATURES } from 'config/nav';
import type { NavContext } from 'config/nav';
import { useAuthState } from 'lib/authState';

export function useNavContext(): NavContext {
    return { auth: useAuthState(), features: FEATURES };
}

export function useAccountActions() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    return {
        signIn: () => SuperTokens.redirectToAuth(),
        signOut: async () => {
            await signOut();
            // Per-user queries are already keyed by user id; this also drops the
            // signed-out user's cached profile and follows from memory.
            queryClient.removeQueries({ queryKey: ['users'] });
            navigate('/');
        }
    };
}
